import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { FieldStackedLabel } from '../../../Field'
import { Rating, RATING_ITEM_SIZE } from '../../Rating'
import { RATING_TYPE_LABEL_KEY } from '../RatingEditModal.constants'

import * as styles from './RatingEditModalItem.module.css'

function RatingEditModalItem({ disabled, isRequired, rating, type, onClick }) {
  const { t } = useTranslation()

  function handleClick(value) {
    onClick(type, value)
  }

  return (
    <div
      className={classNames(styles.ratingItem, {
        [styles.disabled]: disabled,
      })}
    >
      <FieldStackedLabel
        className={styles.field}
        label={t(RATING_TYPE_LABEL_KEY[type])}
        required={isRequired}
      >
        <Rating
          interactable
          disabled={disabled}
          itemSize={RATING_ITEM_SIZE.size24}
          rating={rating}
          onClickItem={handleClick}
        />
      </FieldStackedLabel>
    </div>
  )
}

export default RatingEditModalItem
